import FArray from '@/plugins/form/FArray';
import Item from './Item';

export default class extends FArray {
  constructor(props) {
    super(props);
    this.tour = props.parent;
  }

  get options() {
    const items = this.correctItems;
    return items.map((i, j) => ({
      value: i.tariffId,
      label: i.name.value || `Тариф ${j + 1}`,
    }));
  }

  get data() {
    return  this.items.map(i => i.data);
  }

  get correctItems() {
    if (this.tour.dontUseTariffs){
      return  this.items.filter(i => i.isDefault) || [];
    }
    return this.items.filter(i => !i.isDefault);
  }

  remove(item) {
    this.tour.services.deleteServicePrice(item);
    super.remove(item);
  }

  set data(value) {
    this.__value = [];
    value.forEach((i) => {
      const item = new Item();
      this.push(item);
      item
        .setData(i)
        .init();
    });
  }

  add() {
    console.log('tarif add');
    const item = new Item();
    this.push(item);
    return item.set()
      .init();
  }
  addDefault() {
    const item = new Item();
    this.push(item);
    return item.set({
      adult: 1,
      isDefault: true,
      age: 0,
      netto: 0,
      agency: 0,
      brutto: 0,
      name: 'Тариф'
    })
      .init();
  }
}
